module.exports = __webpack_public_path__ + "bc4254416c1598f3b876634f9bd301b7.svg";